<template>
  <div>
    <div v-if="isLoading">
      <b-spinner small></b-spinner> {{ $t("loading...") }}
    </div>
    <div v-show="!isLoading">
      <b-row>
        <b-col md="3">
          <b-form-group v-for="f in filters" v-bind:key="f.name" :label="f.caption">
            <b-select v-model="f.value" v-on:change="loadData">
              <b-select-option :value="null">--</b-select-option>
              <b-select-option v-for="d in f.data" v-bind:key="d" :value="d">{{ d }}</b-select-option>
            </b-select>
          </b-form-group>
        </b-col>
        <b-col md="9">
          <column-chart v-if="viewConfig.chartType == 0" :data="chartData" />
          <line-chart v-else-if="viewConfig.chartType == 1" :data="chartData" />
          <area-chart v-else-if="viewConfig.chartType == 2" :data="chartData" />
          <pie-chart v-else-if="viewConfig.chartType == 3" :data="chartData" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ColumnChart from './charts/ColumnChart.vue';
import PieChart from './charts/PieChart.vue';
import AreaChart from './charts/AreaChart.vue';
import LineChart from './charts/LineChart.vue';

import Api from "@/api";

export default {
  components: { ColumnChart, PieChart, AreaChart, LineChart },
  props: ["viewId", "viewConfig"],
  data: () => ({
    isLoading: true,
    chartData: [],
    filters: []
  }),
  created() {
    this.loadData();
    this.loadFilters();
  },
  methods: {
    loadData() {
      let filterString = "";

      this.filters.forEach((filter) => {
        if (filter.value)
          filterString += `${filter.name}=${filter.value}&`;
      });

      filterString = filterString.slice(0, -1);

      Api.getChartData(this.viewId, filterString).then((response) => {
        this.chartData = response;
      }).finally(() => this.isLoading = false);
    },

    loadFilters() {
      if (this.viewConfig.filters !== undefined) {
        this.viewConfig.filters.forEach((filter) => {
          Api.getData(filter.dataUrl)
            .then((response) => this.filters.push({ name: filter.name, caption: filter.caption, data: response, value: null }))
            .catch();
        });
      }
    },
  },
  watch: {
    "viewConfig.filters": {
      handler(value) {
        this.loadFilters();
      }
    }
  }
}
</script>